import Loading from 'Common/Components/Loading';
import React, { Suspense } from 'react';

const LazyLoad: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Suspense fallback={<Loading verticallyCentered noText color="#fff" />}>
    {children}
  </Suspense>
);

export default LazyLoad;
